{
  "source": "RhineMusicDatabase installed resources",
  "files": [
    {
      "name": "archive-cassette.json",
      "bytes": 6221,
      "sha256": "69c0270c9a782b8beba582f737247d3ea975d172e7d0a66041a8f963e341dfd6"
    },
    {
      "name": "archive-cassette.bin",
      "bytes": 638784,
      "sha256": "c68663add3eaf0451873e1f600ee4c34d7cb24647e438eef06491021f95f81c9"
    },
    {
      "name": "archive-cassette-indices.bin",
      "bytes": 278688,
      "sha256": "4132751808ac974a5f2476598801ae2834cb91096999c07a8fcb79b074451145"
    },
    {
      "name": "archive-baked-surface.bin",
      "bytes": 5592404,
      "sha256": "b14ed1aca38329bb20718ae4811a7aa96525779839f79358fbcb0f31107157ea"
    },
    {
      "name": "archive-baked-normal.bin",
      "bytes": 262144,
      "sha256": "6a214b87ba840f08a120402d3172c47a9df3b41a92fe3f0cb8c5d8d872c5c677"
    },
    {
      "name": "archive-baked-light.bin",
      "bytes": 5308416,
      "sha256": "dc7f14987b99eb0480325bbde99151e7acdc0bb5a55df6db66125ec5afdda961"
    },
    {
      "name": "boot-lettering-art.json",
      "bytes": 29697,
      "sha256": "8748e6b2d5431e0243ef0e2d2b4075bf5282a8e2c720cb1fc9a3c5bd7d5c208c"
    },
    {
      "name": "LICENSE",
      "bytes": 1063,
      "sha256": "b42f104f4b3687773c76efbf990c1ab7b306a8c59035958c0b886dfbbcf2cd91"
    },
    {
      "name": "NOTICE",
      "bytes": 12414,
      "sha256": "138c1b964f29529b287f6909d091f2714a9e9d259ed1eb5c26d5c807f99de7e2"
    },
    {
      "name": "MiSans-license.pdf",
      "bytes": 79535,
      "sha256": "4a93a27cd2bd81b3b5ecfd0a853144a876fa26938a93a68443c67d74172fcb86"
    },
    {
      "name": "archive-assembly.json",
      "bytes": 7343,
      "sha256": "166ad46f839409b7d065b17ac361144d9f4fd6dfd9be9f2c0d977890be4c91ac"
    },
    {
      "name": "archive-assembly.bin",
      "bytes": 638784,
      "sha256": "26a70fcb76e2e60c20d14151d83698b8e88bd06e8b275d9de95027dffd68ea48"
    },
    {
      "name": "archive-assembly-indices.bin",
      "bytes": 278688,
      "sha256": "27e47c0c29502cf197ef11378c1813ee674837e9ece7920d04fe0a958d8478eb"
    },
    {
      "name": "quality/kugou-hires.png",
      "bytes": 5658,
      "sha256": "03e4ad9428c402ee00a403479dcde406a975f9e77206e5401b4dc66dddb7de06"
    },
    {
      "name": "quality/kugou-hq.png",
      "bytes": 8540,
      "sha256": "549f32454034c0b31c009458f1e41c7ba5f410cfa2bfd9fb911caaf5031a22c0"
    },
    {
      "name": "quality/kugou-sq.png",
      "bytes": 5576,
      "sha256": "19428d838192fd42267e185ecf04fe29e9f67587335d3d08448253bf6560764f"
    },
    {
      "name": "quality/netease-hires.png",
      "bytes": 3617,
      "sha256": "b63cfd7e3e6d7e5a9da1af04a9bc79e83d8ecd069de4e4dfbc5eb2dbdc865621"
    },
    {
      "name": "quality/netease-jyeffect.png",
      "bytes": 5377,
      "sha256": "c6293ccdf2b28f241dda9535fd1e8e2f18108d3708440eb5c0c434debfd2dd62"
    },
    {
      "name": "quality/netease-jymaster.png",
      "bytes": 5573,
      "sha256": "544513501f54366da23a56ade2667b25054d06c18ff1273248cf4618faca1a11"
    },
    {
      "name": "quality/netease-sky.png",
      "bytes": 4436,
      "sha256": "05d3460e5d430f4096b5903ff72c927c5c9e9e85ccf268be583a90ce33895db5"
    },
    {
      "name": "quality/netease-sq.png",
      "bytes": 3161,
      "sha256": "8ff7193f4793dc37dfdccefbbd677ac42bec560a6a026be116107e9dd45ade1a"
    },
    {
      "name": "quality/qq-hq.png",
      "bytes": 1483,
      "sha256": "1e31efd512ccf26079e9548284e521741c08fcdc42093924b60c798631f5b0a0"
    },
    {
      "name": "quality/qq-sq.png",
      "bytes": 1974,
      "sha256": "72a04f8800b3e7016ef5d82a09f2bd3670a7f4c9d53c7c7ed7df1c8363884b81"
    },
    {
      "name": "quality/sources.json",
      "bytes": 1107,
      "sha256": "74796ca84b7af9c8d2d4158a4b1511ce25bd6acc988fb8276bfc0a7366e8ad82"
    }
  ]
}